import { useSyncExternalStore } from "react";
import { assinarModoValores, obterModoValores, type ModoValores } from "@/lib/modo-valores";
import {
  listarAvisosTitulo,
  montarAvisoTitulo,
  persistenciaBloqueada,
  MOTIVO_BLOQUEIO_PERSISTENCIA,
} from "@/lib/avisos-titulo";

/** Modo de valores global, reativo. */
export function useModoValoresGlobal(): ModoValores {
  return useSyncExternalStore(assinarModoValores, obterModoValores, () => 0 as ModoValores);
}

/** Avisos vigentes para o título da janela. */
export function useAvisosTitulo() {
  const modo = useModoValoresGlobal();
  return { modo, avisos: listarAvisosTitulo(modo), texto: montarAvisoTitulo(modo) };
}

/** Bloqueio de operações que gravam no banco. */
export function useBloqueioPersistencia() {
  const modo = useModoValoresGlobal();
  const bloqueado = persistenciaBloqueada(modo);
  return { bloqueado, motivo: bloqueado ? MOTIVO_BLOQUEIO_PERSISTENCIA : "" };
}
